import { Grid, LinearProgress, Typography } from '@material-ui/core'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Field, reduxForm } from 'redux-form'
import SubmitFormButton from '../../../../components/Buttons/SubmitFormButton'
import { ReduxTextField } from '../../../../components/FormInput/ReduxWrappers'
import { ReduxForm } from '../../../../types/forms'
import {
  validatePassword,
  passwordsMatch,
  required
} from '../../../../utils/validation/forms'

interface ConfirmPasswordResetFormProps extends WithTranslation, ReduxForm {
  confirmReset: (arg: any) => any
}

const ConfirmPasswordResetForm = ({
  confirmReset,
  t,
  handleSubmit,
  submitting,
  error
}: ConfirmPasswordResetFormProps) => (
  <form onSubmit={handleSubmit(confirmReset)}>
    <Grid container direction='row' spacing={1}>
      <Grid item xs={12} sm={12}>
        <Field
          fullWidth
          name='password'
          label={t('person.password')}
          type='password'
          autoComplete='new-password'
          helperText={t('changePw.helperText')}
          validate={[required, validatePassword]}
          component={ReduxTextField}
          required
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <Field
          fullWidth
          name='confirmPassword'
          label={t('signup.confirmPw')}
          type='password'
          autoComplete='off'
          validate={[required, validatePassword, passwordsMatch]}
          component={ReduxTextField}
          required
        />
      </Grid>
      <Grid item xs={12}>
        <SubmitFormButton submitting={submitting} />
      </Grid>
      {submitting && <LinearProgress />}
      {error && (
        <Typography style={{ color: 'red' }} variant='body1'>
          {error}
        </Typography>
      )}
    </Grid>
  </form>
)

export default reduxForm({
  form: 'ConfirmPasswordResetForm'
})(withTranslation()(ConfirmPasswordResetForm as any) as any) as any
